var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w100p fs0"},[_c('van-image',{staticClass:"imgauto",attrs:{"lazy-load":"","src":_vm.img}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }